import store from "../../store/store"
import { MassMailingHub } from "../hubs/massMailing"

export const massMailingHub = new MassMailingHub(store)
